import { state, style, trigger } from '@angular/animations';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewChild
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { debounceTime } from 'rxjs/operators';
import { FilterService } from 'src/app/library/services/filter/filter.service';

@Component({
    selector: 'filter-search',
    templateUrl: './filter-search.component.html',
    styleUrls: ['./filter-search.component.scss'],
    animations: [
        trigger('search', [
            state(
                'default',
                style({
                    color: 'rgba(29, 34, 44, 0.24)'
                })
            ),
            state(
                'default',
                style({
                    display: 'none'
                })
            )
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterSearchComponent implements OnInit, AfterViewInit {
    @ViewChild('search', { static: true }) searchInput: MatInput;
    public searchState = 'search';
    public searchCtrl = new UntypedFormControl('');
    public searchPlaceholder: string;

    constructor(
        private filterService: FilterService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.searchPlaceholder =
            this.filterService.filterConfig.searchPlaceholder;
        this.listeners();

        // If searchText contains a value then set the searchCtrl value to that value
        if (this.filterService.filterConfig.searchText) {
            this.searchCtrl.setValue(
                this.filterService.filterConfig.searchText,
                {
                    emitEvent: true
                }
            );
        }
    }

    ngAfterViewInit() {
        this.searchInput?.focus();
        this.cdr.detectChanges();
    }

    get dataLoading$() {
        return this.filterService.dataLoading$;
    }

    public toggleSearchBox() {
        this.searchState === 'default'
            ? (this.searchState = 'search')
            : (this.searchState = 'default');
        if (this.searchState === 'default') {
            this.filterService.searchText = '';
            this.searchCtrl.setValue('', { emitEvent: false });
            this.filterService.filterChangeEvent();
        }
    }

    public listeners() {
        this.searchCtrl.valueChanges
            .pipe(debounceTime(500))
            .subscribe(async (data: string) => {
                this.filterService.searchText = data;
                this.filterService.filterChangeEvent();
            });
    }
}
